<template>
  <section class="team-list">
    <div class="caption">Teams</div>

    <div align="right">
      <button v-if="!isGameStopped(game)" class="button is-warning" style="margin-left: 5px;" @click="resetAllFingerPrints()">
        Reset all devices
      </button>
    </div>
    <b-table :data="teams" v-if="teams" :loading="isLoading">
      <template slot-scope="props">
        <b-table-column class="centered-table-content cell--profile-picture" field="teamName" label="Avatar">
          <img :src="props.row.imageUrl" />
        </b-table-column>

        <b-table-column class="centered-table-content" field="teamName" label="Team name">
          {{ props.row.teamName }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="battleCry" label="battleCry">
          {{ props.row.battleCry }}
        </b-table-column>

        <b-table-column class="centered-table-content" label="Manage">
          <button @click="editTeam(props.row.idTeam)" v-if="isGameNew" style="margin-left: 5px;" class="button">
            Edit
          </button>
          <button @click="deleteTeam(props.row.idTeam, props.row.teamName)" v-if="isGameNew" style="margin-left: 5px;"
                  class="button is-danger is-outlined">
            Delete
          </button>
          <button class="button is-success" style="margin-left: 5px;"
                  @click="viewTeamProgress(props.row.idTeam, props.row.teamName)">
            View team progress
          </button>
          <button v-if="!isGameStopped(game)" :disabled="!props.row.fingerprint" class="button is-warning"
                  style="margin-left: 5px;" @click="resetFingerPrint(props.row.idTeam)">
            Reset device
          </button>
        </b-table-column>
      </template>
    </b-table>
  </section>
</template>

<script>
import teamsService from '../../services/teamsService'
import GAME_STATUS from '../../enums/gameStatus'
import gameHelper from '../../helpers/game-helper'

export default {
  props: {
    teams: {
      type: Array,
      required: true
    },
    game: {
      type: Object,
      required: true
    },
    isLoading: false,
  },
  computed: {
    isGameNew: function() {
      return this.game.gameStatus === GAME_STATUS.NEW
    }
  },
  methods: {
    isGameStopped: gameHelper.isGameStopped,
    async deleteTeam(idTeam, teamName) {
      try {
        this.isLoading = true
        await teamsService.deleteTeam(idTeam, this.game.idGame)
        this.$emit('displaySuccess', `Team ${teamName} successfully deleted`)
        this.$emit('refreshTeams')
      } catch (err) {
        this.$emit('displayErrors', [err.message])
      } finally {
        this.isLoading = false
      }
    },
    editTeam(idTeam) {
      this.$router.push({ name: 'EditTeam', params: { id: this.game.idGame, idTeam: idTeam } })
    },
    viewTeamProgress(idTeam) {
      this.$router.push({ name: 'ViewTeamProgress', params: { id: this.game.idGame, idTeam: idTeam } })
    },
    async resetFingerPrint(idTeam) {
      try {
        this.isLoading = true
        await teamsService.resetFingerprint(idTeam, this.game.idGame)
        this.$emit('displaySuccess', `Device successfully reset`)
        this.$emit('refreshTeams')
      } catch (err) {
        this.$emit('displayErrors', [err.message])
      } finally {
        this.isLoading = false
      }
    },
    async resetAllFingerPrints() {
      try {
        this.isLoading = true
        await teamsService.resetAllFingerPrints(this.game.idGame)
        this.$emit('displaySuccess', `All devices successfully reset`)
        this.$emit('refreshTeams')
      } catch (err) {
        this.$emit('displayErrors', [err.message])
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.cell--profile-picture img {
  max-width: 60px;
  max-height: 60px;
  border-radius: 50%;
}
.caption {
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 5px;
}
</style>
